import { apiFetch } from '$lib/api/helpers';
import type { ZoneRequest, ZoneResponse } from '$lib/types/zone';

const PATH = '/zones/';

export async function fetchZones() {
	return apiFetch<Array<ZoneResponse>>(PATH);
}

export async function fetchZoneById(id: number) {
	return apiFetch<ZoneResponse>(`${PATH}${id}/`);
}

export async function createZone(zoneRequest: ZoneRequest) {
	return apiFetch<ZoneResponse>(PATH, {
		method: 'POST',
		body: JSON.stringify(zoneRequest)
	});
}

export async function deleteZone(id: number) {
	return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}

export async function updateZone(id: number, zoneRequest: Partial<ZoneRequest>) {
	return apiFetch<ZoneResponse>(`${PATH}${id}/`, {
		method: 'PATCH',
		body: JSON.stringify(zoneRequest)
	});
}

export const patchZone = updateZone;
